import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './ServicePages.css';
import { fadeInUp } from '../constants/animations';

function WebApps() {
  return (
    <main className="service-page">
      <div className="service-container">
        <motion.div className="service-hero" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }}>
          <motion.h1 variants={fadeInUp} custom={0}>Web Apps</motion.h1>
          <motion.p variants={fadeInUp} custom={1}>Custom tools and dashboards built around how your business actually works.</motion.p>
        </motion.div>

        <div className="service-section">
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
            <h4>Operations dashboards</h4>
            <p>Track job progress, pipeline, and team performance.</p>
          </motion.div>
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
            <h4>Automations</h4>
            <p>Reduce manual tasks with tailored workflows.</p>
          </motion.div>
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={2}>
            <h4>Integrations</h4>
            <p>Connect the tools you already use for seamless data flow.</p>
          </motion.div>
        </div>

        <motion.div className="service-block" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }} variants={fadeInUp} custom={0}>
          <h3>What you get</h3>
          <ul className="service-list">
            <li>Custom app architecture</li>
            <li>Role‑based dashboards</li>
            <li>API integrations and automations</li>
            <li>Scalable, maintainable builds</li>
          </ul>
        </motion.div>

        <div className="service-split">
          <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
            <h4>Who it’s for</h4>
            <p>Teams that need more than a brochure site - real internal tools.</p>
          </motion.div>
          <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
            <h4>Built to evolve</h4>
            <p>Start lean, then expand as your processes grow.</p>
          </motion.div>
        </div>

        <motion.div className="service-cta" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.35 }} variants={fadeInUp} custom={0}>
          <Link to="/plans">Get Started</Link>
        </motion.div>
      </div>
    </main>
  );
}

export default WebApps;
